import { RenderSelectInput } from "app/common/renderInput";
import { addUpdateAirlines } from "app/services/vendorService";
import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import * as Yup from "yup";
import UserGroupSearch from "./AutoComplete/UserGroupSearch";
import VendorAndCarrierSearch from "./AutoComplete/VendorAndCarrierSearch";

export default function SupplierAirlinesAddUpdate({
  initialValues,
  setInitialValues,
  show,
  handleClose,
  loadAirlines,
  edit,
  setEdit,
}) {
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [userGroup, setUserGroup] = useState(null);
  const [selectedCarriers, setSelectedCarriers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Validation Schema
  const validationSchema = Yup.object({
    applyToAllUserGroups: Yup.boolean(),
    userGroupId: Yup.number().when("applyToAllUserGroups", {
      is: false, // When applyToAllUserGroups is false...
      then: Yup.number()
        .min(1, "User group is required")
        .required("User group is required"),
      otherwise: Yup.number().optional(),
    }),
    supplierId: Yup.number().min(1, "Supplier is required"),
    carrierIdList: Yup.array().min(1, "At least one airline must be selected"),
  });
  const closeHandler = () => {
    handleClose();
    setEdit(false);
    loadAirlines();
    setInitialValues({
      mode: "ADD",
      supplierId: 0,
      carrierIdList: [],
      status: true,
      userGroupId: 0,
      applyToAllUserGroups: false,
    });
    setSelectedVendor(null);
    setSelectedCarriers([]);
    setUserGroup(null);
  };
  // Submit Handler
  const handleSubmit = async (values, { resetForm }) => {
    const request = {
      ...values,
      mode: edit == false ? "ADD" : "EDIT",
      status: edit == false ? values.status : !values.status,
    };
    if (values.applyToAllUserGroups) {
      delete request.userGroupId;
    }

    setIsLoading(true);
    try {
      const response = await addUpdateAirlines(request);
      if (response.status === "Success") {
        NotificationManager.success(response.message);
      } else {
        NotificationManager.error(response.message);
      }
    } catch (error) {
      NotificationManager.error("Error while saving data");
    }
    setIsLoading(false);
    setSelectedVendor(null);
    setSelectedCarriers([]);
    resetForm(); // Reset form after successful submission
    closeHandler();
  };
  const StatusList = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>
          {edit == false ? "Add" : "Update"} Supplier Airlines
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            setFieldValue,
            touched,
            errors,

            handleBlur,
          }) => (
            <Form>
              <Row>
                <Col>
                  <RenderSelectInput
                    // type="number"
                    name="applyToAllUserGroups"
                    display={
                      <div
                        style={{
                          color: values.applyToAllUserGroups ? "green" : "red",
                        }}
                      >
                        Apply To All User Group
                      </div>
                    }
                    value={values.applyToAllUserGroups}
                    error={errors.applyToAllUserGroups}
                    onChange={(e) => {
                      debugger;
                      const selectedVal = e.target.value;
                      // If the value is a string, convert it
                      const booleanVal =
                        selectedVal == "true" || selectedVal == true;
                      setFieldValue("applyToAllUserGroups", booleanVal);
                    }}
                    onBlur={handleBlur}
                    touched={touched.applyToAllUserGroups}
                    items={StatusList}
                  ></RenderSelectInput>
                </Col>
              </Row>
              {!values.applyToAllUserGroups && (
                <Row className="mb-3">
                  <label>User Group</label>

                  <Col>
                    <UserGroupSearch
                      setSelected={setUserGroup}
                      selected={userGroup}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      name={"userGroupId"}
                      value={values.userGroupId}
                    />
                  </Col>
                </Row>
              )}
              <Row className="mb-3">
                <label>Supplier Name</label>
                <Col>
                  <VendorAndCarrierSearch
                    type="vendor"
                    setSelected={setSelectedVendor}
                    selected={selectedVendor}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    errors={errors}
                    edit={edit}
                    userGroupId={values.userGroupId}
                    value={values.supplierId}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <label>Airlines Name</label>
                <Col>
                  <VendorAndCarrierSearch
                    type="flight"
                    setSelected={setSelectedCarriers}
                    selected={selectedCarriers}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    errors={errors}
                    edit={edit}
                    userGroupId={values.userGroupId}
                    value={values.carrierIdList}
                  />
                </Col>
              </Row>
              {edit && (
                <Row className="mb-3">
                  <Col>
                    <div className="form-check mb-3">
                      <Field
                        type="checkbox"
                        id="status"
                        name="status"
                        className={`form-check-input ${
                          values.status
                            ? "border-danger bg-danger"
                            : "border-primary"
                        }`}
                        checked={values.status} // Invert the value
                        onChange={() => setFieldValue("status", !values.status)} // Toggle status
                        style={{
                          borderColor: "red", // Set border color to red
                          accentColor: values.status ? "red" : "", // Change check color to red when checked
                        }}
                      />
                      <label
                        htmlFor="status"
                        className={`form-check-label fw-bold ${
                          values.status ? "text-danger" : "text-primary"
                        }`}
                      >
                        {values.status ? "Exclude" : "Include"}
                      </label>
                    </div>
                  </Col>
                </Row>
              )}

              <div className="d-flex justify-content-center">
                <Button
                  variant="secondary"
                  onClick={closeHandler}
                  className="me-2"
                >
                  Close
                </Button>
                {isLoading ? (
                  <Button variant="primary" disabled>
                    Please wait...
                  </Button>
                ) : (
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
